import { UserRepository } from '../internal/repositories/UserRepository';
import { LoginType } from '../constants/LoginTypeEnum';
import { IFacebookLogin, ILogin } from '../internal/domain/entities/Login';
import { diContainer, serviceNames } from '../service-setup/diContainer';
import { RampStore } from '../internal/stores/RampStore';
import { DRUPAL_ACCOUNT_ROUTE } from '../routes';

export class LoginSubmittedUseCase {
    private userRepository: UserRepository;
    private formData: ILogin | IFacebookLogin;
    private type?: LoginType;
    private rampStore: RampStore;

    constructor(formData: ILogin | IFacebookLogin, type?: LoginType) {
        this.formData = formData;
        this.type = type;
        this.userRepository = diContainer.get(serviceNames.userRepository);
        this.rampStore = diContainer.get(serviceNames.rampStore);
    }

    public execute = async () => {
        const {
            signIn,
            setErrorMessages,
            overlay: { setFormLoading },
            clearErrorMessages
        } = this.userRepository;
        setFormLoading(true);
        clearErrorMessages();

        const errorKey = await signIn(this.formData, this.type);
        if (!errorKey) {
            this.rampStore.goToExternalUrl(DRUPAL_ACCOUNT_ROUTE);
        } else {
            setErrorMessages([{ transKey: errorKey }]);
            setFormLoading(false);
        }
    };
}
